// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1eJ4S","footer":"ModalInfo_footer__yqliY"};